import styled, { css } from 'styled-components';
import { designTokens } from '../ui/foundation/DesignTokens';

export const InputContainer = styled.div`
  width: 100%;
`;

export const InputForm = styled.div`
  height: 2.5rem;
  width: 100%;
  border-radius: 6px;
  background-color: ${(props) => {
    if (props.error) return designTokens.colors.error[50];
    if (props.disabled) return 'transparent';
    return designTokens.colors.gray[100];
  }};
  padding: 0.6rem 0 0.6rem 1rem;
  margin-top: 0.5rem;
`;

export const InputLabel = styled.label`
  font-size: 1rem;
  font-family: ${designTokens.fonts.heading};
  ${(props) => (props.newTheme ? css`color: ${designTokens.colors.gray[900]};` : css`opacity: 0.5;`)}
`;

export const InputIcon = styled.img`
  margin-left: 1rem;
`;

export const InputValue = styled.input`
  font-family: ${designTokens.fonts.heading};
  font-size: 1rem;
  background: none;
  border: none;
  margin-left: 1rem;
  flex-grow: 2;

  &:focus {
    outline: none;
  }

  &::placeholder {
    opacity: 0.3;
  }
`;

export const InputError = styled.div`
  font-size: 1rem;
  color: ${designTokens.colors.error[500]};
`;
